<template>
  <div class="hello">
    <h1>Välj område</h1>

    <h3>Matematik</h3>
    <br>
<div class="länkfalt">
    <router-link class="länk" to="/logik">
        <img src="../assets/logik.jpg" alt="logik">
      <br>Logik
    </router-link>

    <router-link class="länk" to="/kapplopning">
        <img src="../assets/kapplopning.jpg" alt="kapplopning">
        <br>Hästkapplöpning
    </router-link>



    <router-link class="länk" to="/tjuvochpolis">
        <img src="../assets/tjuvochpolis.jpg" alt="tjuvochpolis">
        <br>Tjuv och polis
    </router-link>


    <router-link class="länk" to="/exponentialekvation1">
        <img src="../assets/exponentialekvation1.jpg" alt="exponentialekvation1">

        <br>Exponentialekvation
    </router-link>

    <router-link class="länk" to="/montyhall">
        <img src="../assets/sportbil.jpg" alt="MontyHall">

        <br>Monty Hall problemet
    </router-link>


  </div>



    <h3>Programmering</h3><br>
    <div class="länkfalt">
        <router-link class="länk" to="/bubbelsortering">
            <img src="../assets/bubbelsortering.jpg" alt="bubbelsortering">
          <br>Bubbelsortering
        </router-link>

        <router-link class="länk" to="/infogandesortering">
            <img src="../assets/infogandesortering.jpg" alt="infogandesortering">
            <br>Infogande sortering
        </router-link>



        <router-link class="länk" to="/urvalssortering">
            <img src="../assets/urvalssortering.jpg" alt="urvalssortering">
            <br>Urvalssortering
        </router-link>


        <router-link class="länk" to="/natverksterminologi">
            <img src="../assets/natverksterminologi.jpg" alt="natverksterminologi">

            <br>Nätverksterminologi
        </router-link>


      </div>
  </div>
</template>

<script>
export default {
  name: 'StartPage',
  title () {
   return `Startsida`
 },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: black;
  text-decoration: none;
}
a:hover{
  text-decoration: underline;
}

.hello {
    min-height: calc(100vh - 71px);
}

.länkfalt{
  display: block;
  height: 200px;
  position: relative;

}
.länk{
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  margin-right: 10px;

}

img{
  border-width: 1px;
  border-style: solid;
  border-color: black;
  height: 130px;
  transition: height 0.2s;
}
img:hover {
  height: 150px;
}

</style>
